module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "hidden-md-and-down",
    attrs: {
      "gutter": 8
    }
  }, [_c('el-col', {
    attrs: {
      "span": this.isManager() ? 18 : 24
    }
  }), _vm._v(" "), (this.isSuper()) ? _c('el-col', {
    attrs: {
      "align": "right",
      "span": _vm.rowData.organisation || _vm.rowData.perosn ? 2 : 24
    }
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSuper()),
      expression: "isSuper()"
    }],
    attrs: {
      "icon": "fa fa-trash",
      "size": _vm.buttonSize,
      "type": "danger",
      "circle": ""
    },
    on: {
      "click": function($event) {
        return _vm.deleteEntry()
      }
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e23657e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sites/sharers/LicenseeControls.vue
// module id = 1518
// module chunks = 0